import { AbstractApiService } from '../abstractions/AbstractApiService';
import { OnRequestError, OnRequestSuccess } from './Responses';

export class PhysiotherapistService extends AbstractApiService {
    constructor() {
        super();
    }

    public GetCurrentPhysiotherapist(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/physiotherapist/current', onSuccess, onError);
    }

    public DeleteProfileImage(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/deletemyprofileimg', onSuccess, onError);
    }

    public GetPhysiotherapist(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/getphysiotherapist?physiotherapistId=' + physiotherapistId.toString(), onSuccess, onError);
    }

    public UpdateAboutMe(aboutMe: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/physiotherapist/updateaboutme', aboutMe, onSuccess, onError);
    }

    public GetMyProfile(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/getmyprofile', onSuccess, onError);
    }

    public GetPhysiotherapistsProfile(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/getphysiotherapistsprofile?physiotherapistId=' + physiotherapistId.toString(),
            onSuccess,
            onError);
    }

    public TinifyMyProfileImg(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/physiotherapist/tinifymyprofileimg', {}, onSuccess, onError);
    }

    public MyProfileImg(imageBase64: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/physiotherapist/myprofileimgbase64', imageBase64, onSuccess, onError);
    }

    public GetMyContactEmail(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/mycontactemail', onSuccess, onError);
    }

    public MyContactEmail(email: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/physiotherapist/mycontactemail', email, onSuccess, onError);
    }

    public ResendContactEmailVeriication( onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/resendcontacemailverification', onSuccess, onError);
    }

    public VerifyMyContactEmail(token: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/physiotherapist/verifymycontactemail', token, onSuccess, onError);
    }

    public DeleteMyContactEmail(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/physiotherapist/deletemycontactemail', onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/PhysiotherapistService.tsx